
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.163 15.925l-2.743-2.751a2.854 2.854 0 00-3.96 0l-1.774 1.774a1.08 1.08 0 01-1.303.18 11.751 11.751 0 01-4.517-4.517 1.123 1.123 0 01.163-1.337L10.803 7.5a2.812 2.812 0 000-3.96L8.086.789A2.631 2.631 0 006.209 0a3.429 3.429 0 00-2.417 1.123L1.409 3.506A4.731 4.731 0 00.723 9.35a42.854 42.854 0 006.154 7.791 42.62 42.62 0 007.714 6.155 4.782 4.782 0 002.572.702 4.73 4.73 0 003.351-1.397l2.649-2.708a2.804 2.804 0 000-3.969zm-1.209 2.752l-2.683 2.751a3.025 3.025 0 01-3.745.437 41.514 41.514 0 01-7.44-5.905A41.142 41.142 0 012.18 8.486a3.026 3.026 0 01.412-3.772l2.417-2.383a1.817 1.817 0 011.2-.617.917.917 0 01.668.283L9.62 4.748a1.089 1.089 0 010 1.543L7.854 8.066A2.837 2.837 0 007.4 11.45a13.97 13.97 0 002.22 2.931c.88.882 1.878 1.638 2.966 2.246a2.803 2.803 0 003.351-.471l1.766-1.774a1.106 1.106 0 011.534 0l2.751 2.76a1.106 1.106 0 010 1.534h-.034z","fill":"currentColor"}})])
          )
        }
      }
    